import { useRef, useState, useEffect } from 'react';
import { useQuery } from 'react-apollo';
import moment from 'moment';

import { SLIDESHOW_REGENERATION_TRESHOLD_MINS } from '../constants';
import { AlbumSlideshowForLastRegeneratedAtCheck } from '../../../../../../../graphql/queries/albums';

const useCanRegenerateSlideshow = ({ albumId }) => {
  const intervalRef = useRef(null);
  const [regenerateThresholdTimeLeft, setRegenerateThresholdTimeLeft] =
    useState(0);
  const { data: { album } = {}, refetch } = useQuery(
    AlbumSlideshowForLastRegeneratedAtCheck,
    {
      variables: {
        id: albumId,
      },
      skip: !albumId,
    },
  );

  const { slideshow } = album ?? {};
  const lastRegeneratedAt = slideshow?.last_regenerated_at
    ? moment(slideshow?.last_regenerated_at)
    : null;

  useEffect(() => {
    if (lastRegeneratedAt) {
      if (intervalRef?.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }

      const lastRegeneratedAtDiff = Math.max(
        0,
        SLIDESHOW_REGENERATION_TRESHOLD_MINS -
          moment().diff(lastRegeneratedAt, 'minutes'),
      );

      if (lastRegeneratedAtDiff > 0) {
        intervalRef.current = setInterval(() => {
          setRegenerateThresholdTimeLeft(prev => prev - 1);
        }, 60000);
        setRegenerateThresholdTimeLeft(lastRegeneratedAtDiff);
      }
    }
  }, [lastRegeneratedAt]);

  useEffect(() => {
    if (regenerateThresholdTimeLeft === 0 && intervalRef?.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [regenerateThresholdTimeLeft]);

  return {
    regenerateThresholdTimeLeft,
    canRegenerateSlideshow: regenerateThresholdTimeLeft <= 0,
    refetchSlideshowForLastRegenerated: refetch,
  };
};

export default useCanRegenerateSlideshow;
